import { render, staticRenderFns } from "./editor_components.vue?vue&type=template&id=da728008&scoped=true"
import script from "./editor_components.vue?vue&type=script&lang=js"
export * from "./editor_components.vue?vue&type=script&lang=js"
import style0 from "./editor_components.vue?vue&type=style&index=0&id=da728008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da728008",
  null
  
)

export default component.exports